import { render, staticRenderFns } from "./FieldSessions.vue?vue&type=template&id=2b4c7bc4&scoped=true"
import script from "./FieldSessions.vue?vue&type=script&lang=js"
export * from "./FieldSessions.vue?vue&type=script&lang=js"
import style0 from "./FieldSessions.vue?vue&type=style&index=0&id=2b4c7bc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4c7bc4",
  null
  
)

export default component.exports